export default __webpack_public_path__ + "static/media/icn-help-off.1237d091.svg";